import { gql, query } from "../utils/client";

import type {
  ApiResponse,
  PresentationData,
  TeacherNoteData,
} from "../types.d";

export async function getTeacherNotesData(id: string) {
  const { data } = await query<ApiResponse<{ teacherNotes: TeacherNoteData }>>({
    query: gql`
      query GetTeacherNotes($sessionId: ID!) {
        teacherNotes(sessionId: $sessionId) {
          contentHtml
          id
        }
      }
    `,
    variables: {
      sessionId: id,
    },
  });

  return {
    data: data.teacherNotes,
  };
}

export async function getSlideData(id: string) {
  const { data } = await query<
    ApiResponse<{ unstable_slides: { data: string } }>
  >({
    query: gql`
      query GetSlides($sessionId: ID!) {
        unstable_slides(sessionId: $sessionId) {
          data
        }
      }
    `,
    variables: {
      sessionId: id,
    },
  });

  return {
    data: {
      presentationSlides: JSON.parse(data.unstable_slides.data),
    } as PresentationData,
  };
}
